import styles from "../styles/Hero.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Hero() {
  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();

  const go = (path) => navigate(`/${lang}${path}`);

  return (
    <section className={styles.Hero}>

      <h1>{t("hero.title")}</h1>
      <p>{t("hero.subtitle")}</p>

      <div className={styles.buttonWrapper}>
        <button onClick={() => go("/book")}>
          {t("hero.cta_book")}
        </button>

        <button onClick={() => go("/discover")}>
          {t("hero.cta_discover")}
        </button>
      </div>

    </section>
  );
}